<button
  type="button"
  [ngClass]="{ 'menu-show':  menuShown, 'menu-loading': isMenuLoading }"
  class="menu-btn"
  [disabled]="!menuData"
  (click)="toggleMenu(); $event.stopPropagation();"
>
  <app-spinner
    *ngIf="isMenuLoading"
    class="menu-btn-spinner"
  ></app-spinner>
</button>

<app-menu
  *ngIf="menuShown"
  [menuData]="menuData"
  (toggleMenu)="toggleMenu($event)"
></app-menu>
